import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import ApplicationCard from "../components/ApplicationCard";
import ProfileMenu from "../components/ProfileMenu";
import { clearTokens, loadTokens, logoutFromSso } from "../components/auth";

function Home() {
  const navigate = useNavigate();

  // Synchronize logout across browser tabs on the same origin
  useEffect(() => {
    const checkAuth = () => {
      const loggedIn = localStorage.getItem("isLoggedIn");
      if (!loggedIn) {
        navigate("/login", { replace: true });
      }
    };

    const handleStorage = (e) => {
      if (e.key === "isLoggedIn" && !e.newValue) {
        navigate("/login", { replace: true });
      }
      if (e.key === "cestaconnect.sso.tokens" && !e.newValue) {
        navigate("/login", { replace: true });
      }
    };

    window.addEventListener("storage", handleStorage);
    window.addEventListener("focus", checkAuth);
    document.addEventListener("visibilitychange", checkAuth);

    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("focus", checkAuth);
      document.removeEventListener("visibilitychange", checkAuth);
    };
  }, [navigate]);

  const isLoggedIn = localStorage.getItem("isLoggedIn");

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const handleSettings = () => {
    navigate("/config");
  };

  const handleLogout = async () => {
    const tokens = loadTokens();
    clearTokens();
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("role");
    localStorage.removeItem("userRole");

    const portalUrl = process.env.REACT_APP_SSO_PORTAL_URL?.replace(/\/$/, "") || window.location.origin;
    const fallbackRedirect = `${portalUrl}/login`;

    try {
      if (tokens && tokens.accessToken) {
        const federatedLogoutUrl = await logoutFromSso(tokens);
        if (federatedLogoutUrl) {
          window.location.href = federatedLogoutUrl;
          return;
        }
      }
    } catch (e) {
      console.warn("SSO backend logout failed:", e);
    }

    window.location.href = fallbackRedirect;
  };

  const applications = [
    {
      title: "SMSC Gateway",
      description: "Campaigns, delivery & fallout management",
      icon: SmsOutlinedIcon,
      url: process.env.REACT_APP_SMSC_URL || "http://localhost:8443",
    },
    {
      title: "USSD Gateway",
      description: "Secure sessions & menu management",
      icon: PhoneAndroidOutlinedIcon,
      url: process.env.REACT_APP_USSD_URL || "http://localhost:3001",
    },
    {
      title: "Biller Platform",
      description: "Onboarding, fallout & channel integration",
      icon: ReceiptLongOutlinedIcon,
      url: process.env.REACT_APP_BILLER_URL || "http://localhost:8445",
    },
  ];

  return (
    <div className="app">

      {/* Header */}
      <header className="header">

        <img
          src="/cestasoft-logo.png"
          alt="CestaSoft Logo"
          className="header-logo-image"
        />

        <div className="header-right">
          <ProfileMenu onSettings={handleSettings} onLogout={handleLogout} />
        </div>
      </header>

      <div className="header-line"></div>

      {/* Main */}
      <main className="main-content">

        <section className="welcome-section">
          <h1>Welcome back</h1>

          <p>
            CestaConnect — your platform workspace
          </p>
        </section>

        {/* Application Cards */}
        <section className="applications">

          {applications.map((application) => (
            <ApplicationCard
              key={application.title}
              application={application}
            />
          ))}

        </section>

      </main>

    </div>
  );
}

export default Home;

